import axios from "axios";
import { LOCALSTORAGE } from "../libs/constants";

const localUrl= process.env.REACT_APP_BACKEND_API_LOCAL;
const devUrl= process.env.REACT_APP_BACKEND_API_DEV;
const prodUrl= process.env.REACT_APP_BACKEND_API_PROD;
const nodeEnv = process.env.NODE_ENV;

const api = axios.create({
    baseURL:  localUrl &&  localUrl !== undefined ? localUrl : nodeEnv === "development" || nodeEnv === "test" ? devUrl : prodUrl ? prodUrl : '/api',
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
    }
});

api.interceptors.request.use(
    (request) => {
        if (localStorage && localStorage.getItem(LOCALSTORAGE.token)) {
            const token = localStorage.getItem(LOCALSTORAGE.token);
            if (token) {
                const bearerToken = "Bearer " + token;
                request.headers = {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": bearerToken
                }
            }
        }
        return request;
    },
    function (error) {
        console.log("REQUEST ERROR", error);
    }
);

api.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        console.log("RESPONSE ERROR", error);
        if(error.response){
            if(error.response.status === 403){
                localStorage.clear();
                window.location.pathname = "/login";
            }
            return Promise.reject(error.response.statusText);
        }
        return Promise.reject("API Error!");
    }
)

export default api;